import { Badge, Wrapper } from '@visualfabriq/vf-ui-kit';

export function SelectedCount({ count }: { count: number }) {
  return (
    <Wrapper alignItems="center" gap={300} aria-label={`${count} Selected`} marginInline="auto 0">
      <Badge shape="circle">{count}</Badge> Selected
    </Wrapper>
  );
}
